import Vue from 'vue'
import _ from "lodash";
import axios from "axios";
import constant from './assets/js/constant';
import util from './assets/js/util';
import filter from './assets/js/filter';
import moment from 'moment';

import Loading from "element-ui";
import store from '@/store/index';

Vue.prototype['CX_API_ROOT'] = process.env.CX_API_ROOT
Vue.prototype['CONST'] = constant
Vue.prototype['Util'] = util
Vue.prototype['Filter'] = filter
Vue.prototype['moment'] = moment
Vue.prototype['Loading'] = Loading
Vue.prototype._ = _

// 注册CX系统所有基础组件
const cxBaseComponents = require.context(
  './components/cx',
  true,
  /[\w-]+\.vue$/
);

cxBaseComponents.keys().forEach((fileName) => {
  const config = cxBaseComponents(fileName)
  const name = Vue.prototype._.upperFirst(Vue.prototype._.camelCase(
    fileName.replace(/^\.\/_/, '').replace(/\.\w+$/, '')
  ));
  Vue.component(name, config.default || config)
});

// 注册CX系统所有业务组件
const webComponents = require.context(
  './components/web',
  true,
  /[\w-]+\.vue$/
);

webComponents.keys().forEach((fileName) => {
  const config = webComponents(fileName)
  const name = Vue.prototype._.upperFirst(Vue.prototype._.camelCase(
    fileName.replace(/^\.\/_/, '').replace(/\.\w+$/, '')
  ));
  Vue.component(name, config.default || config)
});

// 注册CX系统所有过滤器
for(let attr in filter) {
  Vue.filter(attr.toString(), filter[attr]);
}

const msg = (paramObj, info) => {
  let targetParamObj = Object.assign({showClose: true, message: info}, paramObj)
  Vue.prototype.$message(targetParamObj)
};
Vue.prototype['success'] = (info) => {
  msg({type: 'success'}, info)
};
Vue.prototype['warning'] = (info) => {
  msg({type: 'warning'}, info)
};
Vue.prototype['info'] = (info) => {
  msg({type: 'info'}, info)
};
Vue.prototype['error'] = (info) => {
  msg({type: 'error'}, info)
};
Vue.prototype['alert'] = (info, callbackFun, dangerouslyUseHTMLString) => {
  Vue.prototype.$alert(info, '系统提示', {
    confirmButtonText: '确定',
    dangerouslyUseHTMLString: dangerouslyUseHTMLString === undefined ? false : dangerouslyUseHTMLString,
    callback: action => {
      if(callbackFun && callbackFun instanceof Function) {
        callbackFun();
      }
    }
  });
};
Vue.prototype['confirm'] = (info, callbackFun, confirmText, cancelText) => {
  Vue.prototype.$confirm(info, '系统提示', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: (confirmText || '确定'),
    cancelButtonText: (cancelText || '取消'),
    type: 'warning'
  }).then(() => {
    if(callbackFun && callbackFun instanceof Function) {
      callbackFun();
    }
  }).catch(() => {});
};


const ax = axios.create({
  baseURL: process.env.CX_API_ROOT,
  timeout: 1000 * 30,   // 请求超时时间30s
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    // 'Content-Type': 'application/x-www-form-urlencoded',   // 表单提交
  },
  responseType: 'json',
});
// 添加请求拦截器
ax.interceptors.request.use(function (config) {
  config.data.token = store.state.user.token;
  if(store.state.user.loginInfo && store.state.user.loginInfo.Us.client_ids) {
    config.data.client_id = Number(store.state.user.loginInfo.Us.client_ids.split(',')[0]);
  }
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});
// 添加响应拦截器
ax.interceptors.response.use(function (response) {
  let msg = response.data['msg'];
  if (response.data['success']) {

  } else {
    if(msg.indexOf('token is lost') === -1) {
      Vue.prototype.error(msg);
    }
  }
  // 对响应数据做点什么
  return response;
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error);
});

Vue.prototype['post'] = (url, data) => {
  return ax.post(url, data).catch(error => {
    Vue.prototype.error('操作失败！错误信息：' + JSON.stringify(error));
  });
};
Vue.prototype['get'] = (url, data) => {
  return ax.get(url, data).catch(error => {
    Vue.prototype.error('操作失败！错误信息：' + JSON.stringify(error));
  });
};
Vue.prototype['all'] = (requests) => {
  return axios.all(requests).catch(error => {
    Vue.prototype.error('操作失败！错误信息：' + JSON.stringify(error));
  });
};

Vue.prototype.ax = ax;
Vue.prototype.axios = axios;

String.prototype.padLeft = function (len, charStr) {
  let s = this + '';
  return new Array(len - s.length + 1).join(charStr,  '') + s;
};
String.prototype.padRight = function (len, charStr) {
  let s = this + '';
  return s + new Array(len - s.length + 1).join(charStr,  '');
};



// WEBPACK FOOTER //
// ./src/Global.js